import { Provider, inject } from "mobx-react";
import { match, Route, RouteProps, Switch } from "react-router-dom";
import * as React from "react";
// import * as Loadable from "react-loadable";

import PageStore from "app/PageStore";
import { PageLoading, NotFound } from "components/Layout";

import RfeStore from "./RfeStore";
import RfeService from "./RfeService";
import BlockStore from "./BlockStore";
import CanvasStore from "./CanvasStore";

const RfeUploadPage = React.lazy(() => import("./views/RfeUploadPage"));
const RfeEditPage = React.lazy(() => import("./views/RfeEditPage"));

interface RoutesProps {
  parentPath: string;
  match: match<{}>;
  pageStore?: PageStore;
}

@inject("pageStore")
class Routes extends React.Component<RoutesProps> {
  private stores = {};

  constructor(props: RoutesProps) {
    super(props);

    const rfeService = new RfeService();
    const rfeStore = new RfeStore(props.pageStore!, rfeService);
    const blockStore = new BlockStore(props.pageStore!, rfeService);
    const canvasStore = new CanvasStore();
    this.stores = {
      rfeStore,
      blockStore,
      canvasStore,
    };
  }

  public render() {
    const matchedUrl = this.props.match.url;
    return (
      <React.Suspense fallback={<PageLoading />}>
        <Provider {...this.stores}>
          <Switch>
            <Route exact path={matchedUrl} render={this.renderRfeUploadPage} />
            <Route path={`${matchedUrl}/pdfs`} render={this.renderPdfsPage} />
            <Route component={NotFound} />
          </Switch>
        </Provider>
      </React.Suspense>
    );
  }

  private renderRfeUploadPage = (routerProps: RouteProps) => (
    <RfeUploadPage
      {...routerProps}
      trail={[
        {
          name: "RFE",
          url: "/",
        },
      ]}
    />
  );

  private renderPdfsPage = ({ match: matchProps }: any) => {
    return (
      <>
        <Route
          path={`${matchProps.path}/:pdfId/images`}
          render={this.renderImagesPage}
        />
        <Route
          exact
          path={`${matchProps.path}/:pdfId`}
          render={this.renderRfeEditPage}
        />
      </>
    );
  };

  private renderImagesPage = ({ match: matchProps }: any) => {
    return (
      <>
        <Route
          path={`${matchProps.path}/:imageId/blocks`}
          render={this.renderBlocksPage}
        />
        <Route
          exact
          path={`${matchProps.path}/:imageId`}
          render={this.renderRfeEditPage}
        />
      </>
    );
  };

  private renderBlocksPage = ({ match: matchProps }: any) => {
    return (
      <Route
        path={`${matchProps.path}/:blockId`}
        render={this.renderRfeEditPage}
      />
    );
  };

  private renderRfeEditPage = (routerProps: RouteProps) => (
    <RfeEditPage
      {...routerProps}
      trail={[
        {
          name: "RFE",
          url: "/",
        },
      ]}
    />
  );
}

export default Routes;
